import React from "react";
import { Link } from "react-router-dom";
import { Copy, ArrowRight, Zap } from "lucide-react";
import { toast } from "sonner";

/**
 * WhyJoinNowReel — /share/why-join-now
 * Urgency angle: paid tiers land this week; sign up NOW to be grandfathered.
 */
const CAPTION = `⏰ Free membership is closing this week.

Sign up NOW (60 secs, no card) and every feature on CampCompass UK is yours free while we grow. Paid tiers land in days — early sign-ups keep their free access.

22,000+ UK campsites (300 rotate free every Monday · sign up to unlock the rest) · real prices · Campfire Chat · trip photos · weather alerts.

👉 camp-compass.uk
#CampCompass #UKCamping #JoinNow`;

export default function WhyJoinNowReel() {
  const copy = () => navigator.clipboard.writeText(CAPTION).then(() => toast.success("Caption copied"));
  return (
    <div className="min-h-screen bg-[#fffbf2]" data-testid="why-join-now-reel">
      <div className="max-w-[420px] mx-auto p-4 space-y-3">
        <div className="text-center">
          <Link to="/launch-pack" className="text-[11px] mono uppercase tracking-widest text-[#ff4500] hover:underline">← Back to Launch Pack</Link>
          <h1 className="font-display text-2xl mt-1">Reel · Why Join Now</h1>
          <p className="text-xs text-[#666]">3 scenes · 9:16</p>
        </div>
        <button onClick={copy} className="w-full inline-flex items-center justify-center gap-2 bg-[#0e0e0e] text-white text-xs font-black uppercase tracking-widest px-4 py-2.5" data-testid="join-copy">
          <Copy className="w-3 h-3" /> Copy caption
        </button>

        <Scene bg="from-[#a82e00] via-[#e03d00] to-[#ff4500]" testid="join-scene-1">
          <div className="text-white text-center flex-1 flex flex-col items-center justify-center p-6">
            <div className="inline-flex items-center gap-1.5 bg-white/20 px-3 py-1 text-[11px] mono uppercase tracking-widest font-black mb-4">
              <Zap className="w-3 h-3" /> Last free window
            </div>
            <div className="font-display text-5xl leading-none mb-3">Days left.</div>
            <p className="text-white/95 text-lg leading-tight">Free membership closes this week.</p>
          </div>
        </Scene>

        <Scene bg="from-[#0e0e0e] via-[#1a1a1a] to-[#2a1300]" testid="join-scene-2">
          <div className="text-white text-center flex-1 flex flex-col items-center justify-center p-6">
            <div className="font-display text-3xl leading-tight mb-4">Sign up now → keep everything free, for life.</div>
            <p className="text-white/80 text-sm">Every feature on the app · free while we grow · no card ever needed.</p>
            <p className="text-white/60 text-xs mt-4 italic">Sign up after paid tiers launch → pay to unlock.</p>
          </div>
        </Scene>

        <Scene bg="from-[#0a7f3f] via-[#0e8f4a] to-[#083c1e]" testid="join-scene-3">
          <div className="text-white text-center flex-1 flex flex-col items-center justify-center p-6">
            <div className="font-display text-4xl leading-tight mb-4">Grab your spot.</div>
            <div className="bg-white text-[#0a7f3f] font-black uppercase tracking-widest text-xs px-5 py-3 inline-flex items-center gap-2">
              camp-compass.uk <ArrowRight className="w-3.5 h-3.5" />
            </div>
            <p className="text-white/85 text-xs mt-4">60 seconds · no card · no catch</p>
          </div>
        </Scene>
      </div>
    </div>
  );
}

function Scene({ bg, testid, children }) {
  return (
    <div className={`aspect-[9/16] w-full flex flex-col bg-gradient-to-br ${bg}`} data-testid={testid}>
      {children}
    </div>
  );
}
